// Angular
import { inject, Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { filter } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class UpdateWorkerService {
    private swUpdateService = inject(SwUpdate);
    private timeout!: ReturnType<typeof setTimeout>;

    init() {
        this.swUpdateService.versionUpdates
            .pipe(filter((e) => e.type === "VERSION_READY"))
            .subscribe(() => {
                this.swUpdateService.activateUpdate().then(() => {
                    document.location.reload();
                });
            });

        this.subscribe();
    }

    subscribe() {
        if (typeof window !== "undefined") {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                const lastRequiestTime = localStorage.getItem("update-worker:ts");

                if (lastRequiestTime && Date.now() - Number(lastRequiestTime) < 60000) {
                    this.subscribe();
                    return;
                }

                this.swUpdateService
                    .checkForUpdate()
                    .then((hasNewVersionFounAndIsReadyToBeActivated: boolean) => {
                        if (hasNewVersionFounAndIsReadyToBeActivated) {
                            this.swUpdateService
                                .activateUpdate()
                                .then(() => document.location.reload());
                        }
                    })
                    .finally(() => {
                        localStorage.setItem("update-worker:ts", `${Date.now()}`);
                        this.subscribe();
                    });
            }, 60000);
        }
    }
}
